import { makeStyles } from '@material-ui/core/styles';

/**
 * Shared styles for warning messages across validation components
 */
export const useValidationWarningStyles = makeStyles({
  warningText: {
    color: '#856404',
    fontSize: '0.75rem',
    marginTop: '4px',
  },
});
